import { Outlet } from "react-router-dom";

function ProjectLayout() {
  return (
    <>
      <Outlet />
    </>
  );
}

export default ProjectLayout;
